import React, { useEffect, useState } from "react";
import {
  collection,
  onSnapshot,
  orderBy,
  query
} from "firebase/firestore";
import { db } from "../firebase";

import styles from "../styles/ReplyList.module.css";

export default function ReplyList({ postId }) {
  const [replies, setReplies] = useState([]);

  useEffect(() => {
    const repliesRef = collection(db, "posts", postId, "replies");
    const q = query(repliesRef, orderBy("createdAt", "asc"));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const replyData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setReplies(replyData);
    });

    return () => unsubscribe();
  }, [postId]);

  return (
    <div className={styles.container}>
      <h4 className={styles.heading}>Replies</h4>
      {replies.length === 0 ? (
        <p className={styles.emptyState}>No replies yet.</p>
      ) : (
        replies.map((reply) => (
          <div key={reply.id} className={styles.replyItem}>
            <div className={styles.replyHeader}>
              <strong className={styles.author}>{reply.author}</strong>
              <small className={styles.timestamp}>
                {reply.createdAt?.toDate
                  ? reply.createdAt.toDate().toLocaleString()
                  : "Just now"}
              </small>
            </div>
            <p className={styles.text}>{reply.text}</p>
          </div>
        ))
      )}
    </div>
  );
}
